module.exports = ".table_cell {\r\n  padding: 8px 8px 8px 0;\r\n}\r\n"